import React, {useContext, useEffect, useState} from 'react';
import {Box, Card, CardContent, Typography} from '@mui/material';
import {connect} from 'react-redux';
import {getAnalytics, logEvent, setUserId as setAnalyticsUser} from "firebase/analytics";
import {FirebaseContext} from "../firebase/FirebaseProvider";
import Login from "./Login";
import {getAuth, isSignInWithEmailLink, onAuthStateChanged} from "firebase/auth";
import {selectUser} from "../../redux/selectors/firebase";
import {updateUserId} from "../../redux/slices/editor";
import {makeStyles} from "@mui/styles";
import * as Sentry from "@sentry/browser";
import {User} from "@sentry/types";
import EmailLinkConfirm from "./EmailLinkConfirm";

const useStyles = makeStyles((theme) => ({
    card: {
        padding: theme.spacing(4)
    },
	modal: {
        padding: theme.spacing(4),
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
	}
}));
type Props = {
    children?: React.ReactNode
    updateUserId: (userId: string) => void
    user?: { [key: string]: unknown }
}
function Authentication ({children, updateUserId, user}: Props) {
    const classes = useStyles();
    const auth = getAuth();
    const {trackUser} = useContext(FirebaseContext);
    const [showLogin, setShowLogin] = useState(false);

    useEffect(() => {
        onAuthStateChanged(auth, (authenticated) => {
            if (authenticated !== null) {
                const analytics = getAnalytics();
                const sentryUser: User = {
                    id: authenticated.uid
                };

                updateUserId(authenticated.uid);
                setAnalyticsUser(analytics, authenticated.uid);
                logEvent(analytics, "login", {
                    method: authenticated.providerId === "google.com" ? "google" : "email-password"
                });
                if (authenticated.email !== null) {
                    sentryUser.email = authenticated.email;
                    window.localStorage.setItem("emailForSignIn", authenticated.email);
                }
                if (authenticated.displayName) {
                    sentryUser.username = authenticated.displayName
                }
                Sentry.setUser(sentryUser);
                trackUser(authenticated.uid);
                setShowLogin(false);

                const searchParameters = new URLSearchParams(window.location.search);
                
                if (searchParameters.get("mode") === "signIn") {
                    searchParameters.set("mode", "intertitle");
                    window.location.search = searchParameters.toString();
                }
            } else {
                setShowLogin(true);
            }
        });
    }, [auth, trackUser, updateUserId])

    if (showLogin) {
        // Not authenticated
        if (isSignInWithEmailLink(auth, window.location.href)) {
            return <EmailLinkConfirm/>
        } else {
            return <Login/>
        }
    } else if (! user) {
        // Authenticated and waiting for user data
        return null;
	} else if (! user.roles) {
        // Authenticated without roles
        return (
            <Box className={classes.modal}>
                <Card className={classes.card}>
                    <CardContent>
                        <Typography>You are authenticated but do not currently have permission to view the database.</Typography>
                        <Typography>You can request permission from alex.w@flavourworks.co.uk</Typography>
                    </CardContent>
                </Card>
            </Box>
        );
	} else {
        // Authenticated
        return (
            <>
                {children}
            </>
        );
	}
}

const mapStateToProps = (store: never) => ({
    user: selectUser(store),
});

export default connect(mapStateToProps, {
    updateUserId
})(Authentication);
